export enum OrderStatus
{
    Created = 0,
    Confirmed = 10,
    Sent = 20
}